import '@testing-library/jest-dom';

describe('Example', () => {
  it('passes', async () => {
    const value = 'test';
    expect(value).toEqual(value);
  });
});
